import util from '@/libs/util'

const post = util.ajax.post

export const devicemainUrls = [
  // 查询尾气检测列表
  '/tailgasdevice/devices'
]

export const devicemain = {}

devicemain.listDevices = function (params) {
  return post('/tailgasdevice/devices', params)
}

devicemain.listDeviceLogs = function (params) {
  return post('/deviceoperationlog/list', params)
}

// 解绑
devicemain.unBind = function (params) {
  return post('/tailgasdevice/unbind', params)
}
// 更改设备类型
devicemain.changeType = function (params) {
  return post('/tailgasdevice/updateDevice', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/device/devicemain.js